import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuthenticationStore, { AuthenticationViews } from "./Store";
import VerifyPhone from './VerifyPhone'

const VerifyPhoneContainer: React.FC = () => {
  const { state, dispatch, attemptVerifyPhone, resendVerificationCode } = useAuthenticationStore()
  const { serverError, isLoading, emailOrPhone, resendWait, verificationCode } = state
  const navigate = useNavigate();

  const setVerificationCode = (newVerificationCode: string) => {
    dispatch({ type: 'SET_VERIFICATION_CODE', payload: newVerificationCode })
  }

  useEffect(() => {
    if (!emailOrPhone) {
      navigate('../' + AuthenticationViews.join)
    }
  }, [emailOrPhone, navigate])

  return (
    <VerifyPhone
      serverError={serverError}
      isLoading={isLoading}
      emailOrPhone={emailOrPhone}
      resendWait={resendWait}
      verificationCode={verificationCode}
      attemptVerifyPhone={attemptVerifyPhone}
      resendVerificationCode={resendVerificationCode}
      setVerificationCode={setVerificationCode}
    />
  )
}

export default VerifyPhoneContainer